export const whiteLabelLogoKeys = {
	whiteLabelLogo: (logoPath: string) => ["white-label-logo", logoPath],
};
